//TODO: refactor and/or use jquery?

function reviewForm() {
    var self = this;

    var experienceTitle = document.getElementById('experienceTitle');
    var experienceId = document.getElementById('experienceId');
    var experiences = document.getElementById('experiences');
    var experiencesHeading = document.getElementById('experiencesHeading');

    this.setExperience = function (match) {
        experienceId.value = match.id
        experienceTitle.value = match.title;
        experiencesHeading.classList.remove('has-matches');
        experiences.innerHTML = "";
    }

    if (experienceTitle) {
        customAutoComplete(experienceTitle, '/experiences?skip=0&take=4&search=', function (res) {
            experiencesHeading.classList.remove('has-matches');
            experiences.innerHTML = "";

            if (!res) return;
            var matches = res.data.results || res.data;
            //TODO: polyfill for classList in IE9, 8?
            
            if (matches && matches.length) {
                experiencesHeading.classList.add('has-matches');
                for (var i = 0; i < matches.length; i++) {
                    var match = matches[i];
                    var link = document.createElement('a');
                    link.classList.add('pointer');
                    link.innerText = match.title; //TODO: also, rating
                    link.onclick = function () {
                        self.setExperience(match);
                    };
                    experiences.appendChild(link);
                }

                var link = document.createElement('a');
                link.classList.add('pointer');
                link.innerText = "This experience provider is not listed yet.";
                link.onclick = function () {
                    self.setExperience({ id: null, title: experienceTitle.value });
                };
                experiences.appendChild(link);
            }
        });
    }

}